<template>
  <div class="row">
    <div class="col-12 form-group form-group-sm">
      <label class="label">Cobranzas</label>
      <div class="card">
        <div class="card-body">
          <div class="container">
            <div class="row">
              <div class="col-12 form-group form-group-sm">
                <label class="label" for="idCobranzaLugarDePago"
                  >Lugar Cobranzas</label
                >
                <SelectorLugarCobranza v-model="idCobranzaLugarDePago" />
              </div>
            </div>
            <div class="row" v-if="this.tarjeta">
              <TarjetaForm :idCobranzaLugarDePago="idCobranzaLugarDePago" />
            </div>
            <div class="row" v-if="this.codigoRapipago">
              <CodigoRapipago :idCobranzaLugarDePago="idCobranzaLugarDePago" />
            </div>
            <div class="row">
              <div class="col-12 form-group form-group-sm">
                <label class="label" for="idClienteReferenciador"
                  >Referenciado por:</label
                >
                <SelectorClienteVigente
                  v-model="idClienteReferenciador"
                  placeholder="Seleccione cliente referenciador"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectorClienteVigente from "../shared/SelectorClienteVigente.vue";
import SelectorLugarCobranza from "../shared/SelectorLugarCobranza.vue";
import TarjetaForm from "./TarjetaForm.vue";
import CodigoRapipago from "./CodigoRapipago.vue";
export default {
  name: "CobranzasForm",
  components: {
    SelectorClienteVigente,
    SelectorLugarCobranza,
    TarjetaForm,
    CodigoRapipago,
  },
  data: () => ({
    tarjeta: false,
    codigoRapipago: false,
  }),
  computed: {
    idCobranzaLugarDePago: {
      get() {
        return this.$store.state.clientes.NuevoCliente.idCobranzaLugarDePago;
      },
      set(val) {
        this.$store.commit(
          "clientes/NuevoCliente/setIdCobranzaLugarDePago",
          val,
        );
      },
    },
    idClienteReferenciador: {
      get() {
        return this.$store.state.clientes.NuevoCliente.idClienteReferenciador;
      },
      set(val) {
        this.$store.commit(
          "clientes/NuevoCliente/setIdClienteReferenciador",
          val,
        );
      },
    },
  },
  methods: {},
  watch: {
    idCobranzaLugarDePago(val) {
      if (val && val.id_ubicacion_dinero) {
        switch (val.id_ubicacion_dinero) {
          case 29: // tarjeta de credito
            this.$store.commit("clientes/NuevoCliente/setTipoTarjeta", "C");
            this.$store.commit("clientes/NuevoCliente/setCodigoRapipago", null);
            this.tarjeta = true;
            this.codigoRapipago = false;
            break;
          case 48: // tarjeta de debito
            this.$store.commit("clientes/NuevoCliente/setTipoTarjeta", "D");
            this.$store.commit("clientes/NuevoCliente/setCodigoRapipago", null);
            this.tarjeta = true;
            this.codigoRapipago = false;
            break;
          case 33: // rapipago
            this.codigoRapipago = true;
            this.tarjeta = false;
            this.$store.commit("clientes/NuevoCliente/setTipoTarjeta", null);
            this.$store.commit("clientes/NuevoCliente/setNroTarjeta", null);
            break;
          default:
            this.tarjeta = false;
            this.codigoRapipago = false;
            this.$store.commit("clientes/NuevoCliente/setTipoTarjeta", null);
            this.$store.commit("clientes/NuevoCliente/setCodigoRapipago", null);
            this.$store.commit("clientes/NuevoCliente/setNroTarjeta", null);
            break;
        }
      }
    },
  },
};
</script>

<style scoped></style>
